import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Close from "@material-ui/icons/Close";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Constant } from "../../Constant";
import { toggleLoginDialog } from "../../redux/action";
import { getFormId } from "../../redux/selector";
import Notifaction from "../Header/Notification";
import IamsmartLoginButton from "../IamsmartLoginButton/IamsmartLoginButton";
import LoginPublicDialog from "../LoginPublicDialog/LoginPublicDialog";
import LoginSSLODialog from "../LoginSSLODialog/LoginSSLODialog";
const useStyles = makeStyles({
    tcRoot: {
        "& .MuiDialog-paperWidthSm": {
            maxWidth: "600px",
        },
    },
    enRoot: {
        "& .MuiDialog-paperWidthSm": {
            maxWidth: "700px",
        },
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
});

const iamSmartBtnStyle = makeStyles((theme) => ({
    root: {
        borderRadius: 6,
        backgroundColor: theme.palette.iamSmart.main,
        color: theme.palette.common.white,
        textTransform: "none",
        "&:hover": {
            backgroundColor: theme.palette.iamSmart.main,
        },
        // height: "3rem",
        fontSize: "1.1em", // 37% of height, min 12px
        "@media (max-width: 500px)": {
            minHeight: "3.5rem",
            height: "auto",
            minWidth: "14rem",
            fontSize: "1em", // 37% of height, min 12px
        },
    },
    titleSty: {
        fontSize: "0.84em", // 37% of height, min 12px
        "@media (max-width: 500px)": {
            fontSize: "0.84em", // 37% of height, min 12px
        },
    },
    labelSty: {
        fontSize: "1.3em", // 37% of height, min 12px
        "@media (max-width: 500px)": {
            fontSize: "1em", // 37% of height, min 12px
        },
    },
    bottonBox: {
        display: "flex",
        alignItems: "center",
    },
    xxxs: {
        "@media (min-width: 560px)": {
            minWidth: "auto",
        },
    },
}));

function LoginDialog({ formOpen, onLogin, onClose = () => {} }) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");

    const dispatch = useDispatch();
    const formId = useSelector(getFormId());
    const [openLogin, setOpenLogin] = useState("");
    const iamSmartBtnClasses = iamSmartBtnStyle();
    const redirect = window.location.pathname + window.location.search;

    useEffect(() => {
        if (formOpen) {
            dispatch(toggleLoginDialog(true));
        }
    }, [formOpen, dispatch]);
    function isLoginMethodVisible(formId, method) {
        const formApplicantLoginMethodList =
            Constant.formApplicantLoginMethod || {};
        if (!formApplicantLoginMethodList[formId]) {
            return true;
        }
        return formApplicantLoginMethodList[formId].includes(method);
    }
    return (
        <React.Fragment>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={formOpen}
                classes={{
                    root:
                        i18n.language === "en"
                            ? classes.enRoot
                            : classes.tcRoot,
                }}
            >
                {openLogin === "" && (
                    <>
                        <Box
                            sx={{
                                position: "relative",
                                minWidth: { xs: "auto", sm: "500px" },
                            }}
                        >
                            <Notifaction />
                            <DialogTitle id="simple-dialog-title">
                                <Grid
                                    container
                                    spacing={1}
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Grid
                                        item
                                        xs={11}
                                        classes={{
                                            root: iamSmartBtnClasses.titleSty,
                                        }}
                                    >
                                        {t("common.iamsmart.loginMethod")}
                                    </Grid>
                                    <Grid item xs={1}>
                                        <IconButton
                                            aria-label="cancel"
                                            onClick={onClose}
                                        >
                                            <Close />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </DialogTitle>
                            <DialogContent>
                                <Grid container spacing={2} direction="column">
                                    {Config.DISPLAY_CLO_LOGIN &&
                                        isLoginMethodVisible(formId, "CLO") && (
                                            <Grid
                                                container
                                                alignItems="center"
                                                spacing={2}
                                            >
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={
                                                        i18n.language === "en"
                                                            ? 3
                                                            : 4
                                                    }
                                                    md={
                                                        i18n.language === "en"
                                                            ? 3
                                                            : 4
                                                    }
                                                >
                                                    <Box
                                                        classes={{
                                                            root: iamSmartBtnClasses.labelSty,
                                                        }}
                                                        textAlign={{
                                                            xs: "center",
                                                            sm: "left",
                                                        }}
                                                    >
                                                        {t(
                                                            "common.portal.loginCLOTitle"
                                                        )}
                                                    </Box>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={
                                                        i18n.language === "en"
                                                            ? 9
                                                            : 8
                                                    }
                                                    md={
                                                        i18n.language === "en"
                                                            ? 9
                                                            : 8
                                                    }
                                                >
                                                    <Box
                                                        p={{ xs: 2, sm: 5 }}
                                                        classes={{
                                                            root: iamSmartBtnClasses.bottonBox,
                                                        }}
                                                    >
                                                        <Button
                                                            variant="contained"
                                                            fullWidth
                                                            classes={{
                                                                root: iamSmartBtnClasses.root,
                                                            }}
                                                            onClick={() => {
                                                                if (redirect)
                                                                    localStorage.setItem(
                                                                        "login_redirect",
                                                                        redirect
                                                                    );
                                                                window.location.href = `${Config.CLO_LOGIN}`;
                                                            }}
                                                        >
                                                            {t(
                                                                "common.portal.loginCLO"
                                                            )}
                                                        </Button>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        )}
                                    {isLoginMethodVisible(formId, "SSLO") && (
                                        <Grid
                                            container
                                            alignItems="center"
                                            spacing={2}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                sm={
                                                    i18n.language === "en"
                                                        ? 3
                                                        : 4
                                                }
                                                md={
                                                    i18n.language === "en"
                                                        ? 3
                                                        : 4
                                                }
                                            >
                                                <Box
                                                    classes={{
                                                        root: iamSmartBtnClasses.labelSty,
                                                    }}
                                                    textAlign={{
                                                        xs: "center",
                                                        sm: "left",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.loginSSLOTitle"
                                                    )}
                                                </Box>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={
                                                    i18n.language === "en"
                                                        ? 9
                                                        : 8
                                                }
                                                md={
                                                    i18n.language === "en"
                                                        ? 9
                                                        : 8
                                                }
                                            >
                                                <Box
                                                    p={{ xs: 2, sm: 5 }}
                                                    classes={{
                                                        root: iamSmartBtnClasses.bottonBox,
                                                    }}
                                                >
                                                    <Button
                                                        variant="contained"
                                                        fullWidth
                                                        classes={{
                                                            root: iamSmartBtnClasses.root,
                                                        }}
                                                        onClick={() => {
                                                            setOpenLogin(
                                                                "SSLO"
                                                            );
                                                        }}
                                                    >
                                                        {t(
                                                            "common.portal.loginSSLO"
                                                        )}
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    )}
                                    {isLoginMethodVisible(formId, "PUBLIC") && (
                                        <Grid
                                            container
                                            alignItems="center"
                                            spacing={2}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                sm={
                                                    i18n.language === "en"
                                                        ? 3
                                                        : 4
                                                }
                                                md={
                                                    i18n.language === "en"
                                                        ? 3
                                                        : 4
                                                }
                                            >
                                                <Box
                                                    classes={{
                                                        root: iamSmartBtnClasses.labelSty,
                                                    }}
                                                    textAlign={{
                                                        xs: "center",
                                                        sm: "left",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.publicLoginTitle"
                                                    )}
                                                </Box>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={
                                                    i18n.language === "en"
                                                        ? 9
                                                        : 8
                                                }
                                                md={
                                                    i18n.language === "en"
                                                        ? 9
                                                        : 8
                                                }
                                            >
                                                <Box
                                                    p={{ xs: 2, sm: 5 }}
                                                    classes={{
                                                        root: iamSmartBtnClasses.bottonBox,
                                                    }}
                                                >
                                                    <Button
                                                        variant="contained"
                                                        fullWidth
                                                        classes={{
                                                            root: iamSmartBtnClasses.root,
                                                        }}
                                                        onClick={() => {
                                                            setOpenLogin(
                                                                "public"
                                                            );
                                                        }}
                                                    >
                                                        {t(
                                                            "common.portal.publicDialogLogin"
                                                        )}
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    )}
                                    {isLoginMethodVisible(
                                        formId,
                                        "IAMSMART"
                                    ) && (
                                        <Grid
                                            container
                                            alignItems="center"
                                            spacing={2}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                sm={
                                                    i18n.language === "en"
                                                        ? 3
                                                        : 4
                                                }
                                                md={
                                                    i18n.language === "en"
                                                        ? 3
                                                        : 4
                                                }
                                            >
                                                <Box
                                                    classes={{
                                                        root: iamSmartBtnClasses.labelSty,
                                                    }}
                                                    textAlign={{
                                                        xs: "center",
                                                        sm: "left",
                                                    }}
                                                ></Box>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={
                                                    i18n.language === "en"
                                                        ? 9
                                                        : 8
                                                }
                                                md={
                                                    i18n.language === "en"
                                                        ? 9
                                                        : 8
                                                }
                                            >
                                                <Box p={{ xs: 2, sm: 5 }}>
                                                    <IamsmartLoginButton
                                                        onLogin={onLogin}
                                                    />
                                                </Box>
                                                <Box
                                                    width="100%"
                                                    textAlign={{
                                                        xs: "center",
                                                        sm: "left",
                                                    }}
                                                    mt={{ xs: 1, sm: 0 }}
                                                >
                                                    <a
                                                        href={
                                                            "https://www.iamsmart.gov.hk/" +
                                                            i18n.language
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        style={{
                                                            whiteSpace:
                                                                "nowrap",
                                                        }}
                                                    >
                                                        {t(
                                                            "common.iamsmart.moreInfo"
                                                        )}
                                                    </a>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Grid>
                            </DialogContent>
                        </Box>
                    </>
                )}
                {openLogin === "SSLO" && (
                    <DialogContent>
                        <LoginSSLODialog onLogin={onLogin} />
                    </DialogContent>
                )}
                {openLogin === "public" && (
                    <DialogContent>
                        <LoginPublicDialog onLogin={onLogin} />
                    </DialogContent>
                )}
            </Dialog>
        </React.Fragment>
    );
}
export default LoginDialog;
